import { ModuleHeader } from "../module-header"
import SubmittedAssignmentsItem from "./submitted-assignments-item"
import { SubmittedAssignmentsCardWrapper } from './submitted-assignments.style'

const SubmittedAssignments = () => {
    return (
        <>
            <ModuleHeader title="SUBMITTED ASSIGNMENTS" />
            <SubmittedAssignmentsCardWrapper>
                <SubmittedAssignmentsItem />
                <SubmittedAssignmentsItem />
                <SubmittedAssignmentsItem />
                <SubmittedAssignmentsItem />
            </SubmittedAssignmentsCardWrapper>
        </>
    )
}

export { SubmittedAssignments }
